var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2261 9H23.8102C28.6542 9 32.0363 12.3381 32.0363 17.1218V30.8782C32.0363 35.6619 28.6542 39 23.8102 39H12.2261C7.38203 39 4 35.6619 4 30.8782V17.1218C4 12.3381 7.38203 9 12.2261 9ZM39.916 13.758C40.794 13.3113 41.824 13.358 42.662 13.8859C43.5 14.4118 44 15.3255 44 16.3245V31.6768C44 32.6778 43.5 33.5894 42.662 34.1153C42.204 34.4016 41.692 34.5478 41.176 34.5478C40.746 34.5478 40.316 34.4463 39.914 34.2412L36.9519 32.7468C35.8559 32.1905 35.1759 31.0737 35.1759 29.8331V18.1661C35.1759 16.9235 35.8559 15.8067 36.9519 15.2544L39.916 13.758Z",
    fill: "#D1D7E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/videoUpload.3d07118b.svg";
export { ForwardRef as ReactComponent };